import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AccueilComponent } from './accueil/accueil.component';
import { ProgrammeComponent } from './programme/programme.component';
import { ArtistesComponent } from './artistes/artistes.component';
import { ArchivesComponent } from './archives/archives.component';
import { TheatreComponent } from './theatre/theatre.component';
import { DecouvrirComponent } from './decouvrir/decouvrir.component';

import { LoginComponent } from './admin/login/login.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { GestionEvenementsComponent } from './admin/gestion-evenements/gestion-evenements.component';
import { GestionArtistesComponent } from './admin/gestion-artistes/gestion-artistes.component';
import { GestionArchivesComponent } from './admin/gestion-archives/gestion-archives.component';
import { GestionTemoignagesComponent } from './admin/gestion-temoignages/gestion-temoignages.component';
import { GestionSondagesComponent } from './admin/gestion-sondages/gestion-sondages.component';
import { MediathequeComponent } from './admin/mediatheque/mediatheque.component';
import { JournalComponent } from './admin/journal/journal.component';
import { ParametresComponent } from './admin/parametres/parametres.component';
import { GenerateurAfficheComponent } from './admin/generateur-affiche/generateur-affiche.component';
import { VueEnsembleComponent } from './admin/vue-ensemble/vue-ensemble.component';
import { AssistantComponent } from './assistant/assistant.component';
import { TraduirePipe } from './pipes/traduire.pipe';
import { ContenuPipe } from './pipes/contenu.pipe';
import { PhotoUploaderComponent } from './admin/shared/photo-uploader/photo-uploader.component';
import { GestionReclamationsComponent } from './admin/gestion-reclamations/gestion-reclamations.component';
import { GestionContenuComponent } from './admin/gestion-contenu/gestion-contenu.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ContactComponent } from './contact/contact.component';

@NgModule({
  declarations: [
    AppComponent,
    AccueilComponent,
    ProgrammeComponent,
    ArtistesComponent,
    ArchivesComponent,
    TheatreComponent,
    DecouvrirComponent,
    LoginComponent,
    DashboardComponent,
    GestionEvenementsComponent,
    GestionArtistesComponent,
    GestionArchivesComponent,
    GestionTemoignagesComponent,
    GestionSondagesComponent,
    MediathequeComponent,
    JournalComponent,
    ParametresComponent,
    GenerateurAfficheComponent,
    VueEnsembleComponent,
    AssistantComponent,
    TraduirePipe,
    ContenuPipe,
    PhotoUploaderComponent,
    GestionReclamationsComponent,
    ContactComponent,
    GestionContenuComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,   // necessaire pour utiliser HttpClient dans les services
    FormsModule         // necessaire pour utiliser [(ngModel)] dans les formulaires
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
